<template>
    <v-row>
        <ActionDropdown 
            :items="actions"
            context="Tracks"
            :alvqa="alvqa"
        />
        <ImportButton                 
            :items="importOptions"
            context="FileBulkImport"
            :alvqa="alvqa"
        /> 
         <v-col 
            cols="3"
            v-if="totalRecords !== null"
            align-self="center"
            class="v-label theme--light mt-3"
        >
            <BaseHeaderStats 
                context="Tracks" 
                typeStats="LIST" 
                :alvqa="alvqa + '-list'" 
            />
         </v-col>
        <v-spacer />
        <v-col 
            cols="2"
            align-self="center"
        >
            <BaseButton 
                label="lang_LABEL_TRACKS_BUTTON_CAPTION_NEW_TRACK"
                :to="{ name: editForm, params: { alvId: 'new' } }"
                block
                color="buttonNewEntity"
                :alvqa="alvqa +'-list-button-new'"
            />
        </v-col>
    </v-row>    
</template>

<script>
import ImportButton from '@/components/_buttons/ImportButton'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'
import ActionDropdown from '@/components/_actions/ActionDropdown'

export default {
    name: "TracksTopSlot",
    data() {
        return {
            editForm: "TracksEdit",
            alvqa: "label-tracks"
        }
    },
    components: {
        ImportButton,
        BaseHeaderStats,
        BaseButton,
        ActionDropdown
    },
    computed:{
        totalRecords() { return this.$store.getters.getTotalRecords },
        
        importOptions() {
            return [
                {
                    text: this.$t("lang_LABEL_TRACKS_BUTTON_OPTION_IMPORT_AUDIO_FILE"), 
                    value: "audioFilesImport", 
                    alvqa: 'label-tracks-list-import-dropdown-audio-file'
                },
                {
                    text: this.$t('lang_ACCOUNT_MAPPINGS'),
                    value: 'mappingImport',
                    alvqa: this.alvqa + '-list-import-dropdown-mapping-import'
                }
            ]
        },
        actions() {
            return [
                {
                    text: this.$t('lang_LABEL_TRACKS_ACTION_OPTION_LABELCOPY'), 
                    value: 'labelcopy', 
                    alvqa: this.alvqa + '-list-action-dropdown-label-copy'
                },
				{
                    text: this.$t('lang_LABEL_TRACKS_ACTION_OPTION_ADD_CONTRACT'), 
                    value: 'addContract',
                    alvqa: this.alvqa + '-list-action-dropdown-add-contract'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_MANAGE_TAGS'),
                    value: 'replaceTags',
                    alvqa: this.alvqa + '-list-action-dropdown-manage-tags'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete', 
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                }
            ]
        }
    }
}
</script>